module.exports = __webpack_public_path__ + "img/vishal.d8c2e549.jpg";